import { render, staticRenderFns } from "./match-detail.vue?vue&type=template&id=a1d8d802&scoped=true&"
import script from "./match-detail.vue?vue&type=script&lang=js&"
export * from "./match-detail.vue?vue&type=script&lang=js&"
import style0 from "./match-detail.vue?vue&type=style&index=0&id=a1d8d802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d8d802",
  null
  
)

export default component.exports